/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpacktitle2Inputs */

const en_creditpacktitle2 = /** @type {(inputs: Creditpacktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy more credits`)
};

const de_creditpacktitle2 = /** @type {(inputs: Creditpacktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits nachkaufen`)
};

/**
* | output |
* | --- |
* | "Buy more credits" |
*
* @param {Creditpacktitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpacktitle2 = /** @type {((inputs?: Creditpacktitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpacktitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpacktitle2(inputs)
	return de_creditpacktitle2(inputs)
});
export { creditpacktitle2 as "creditPackTitle" }